<template>
  <!-- 通知 - 查看消息弹框 -->
  <dialogModel
    :title="dialogTitle"
    :visible="dialogVisible"
    :footer="false"
    @handleClose="handleClose"
  >
    <div class="main-body">
      <div class="msg-content">{{ dataObj.content || "--" }}</div>
      <div class="main-time">{{ $tool.turnTime(dataObj.sendTime) }}</div>
    </div>
  </dialogModel>
</template>

<script>
export default {
  props: {
    dataObj: {
      type: Object,
      default: () => ({}),
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogTitle() {
      return this.dataObj.msgType == 0 ? "系统消息" : "消息";
    },
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>

<style scoped lang="less">
.main-body {
  min-height: 80px;
  padding: 0 4px 8px;
}

.msg-content {
  font-size: 14px;
  color: #333;
  line-height: 24px;
  word-break: break-word;
  white-space: pre-wrap;
  min-height: 60px;
}

.main-time {
  margin-top: 24px;
  text-align: right;
  font-size: 12px;
  color: #999;
  line-height: 20px;
}
</style>
